import { IPlaylist, PlaylistAction } from './types';

export interface IPlaylistState {
  all: IPlaylist[];
  isFetching?: boolean;
  error?: any;
}

const initialState: IPlaylistState = {
  all: [],
  isFetching: false,
  error: null,
};

const upsertPlaylist = (playlists: IPlaylist[], playlist: IPlaylist) => {
  const exists = playlists.find(item => item._id === playlist._id);

  return exists
    ? playlists.map(item => (item._id === playlist._id ? playlist : item))
    : [...playlists, playlist];
};

const replacePlaylist = (
  playlists: IPlaylist[],
  draftId: string | undefined,
  playlist: IPlaylist
) => {
  const withoutDraft =
    draftId && draftId !== playlist._id
      ? playlists.filter(item => item._id !== draftId)
      : playlists;

  return upsertPlaylist(withoutDraft, playlist);
};

const patchPlaylist = (
  playlists: IPlaylist[],
  id: string,
  update: Partial<IPlaylist>
) =>
  playlists.map(
    playlist => (playlist._id === id ? { ...playlist, ...update } : playlist)
  );

export const playlists = (
  state = initialState,
  action: PlaylistAction
): IPlaylistState => {
  switch (action.type) {
    case 'PLAYLISTS/FETCH_ALL_REQUEST':
    case 'PLAYLISTS/FETCH_REQUEST':
    case 'PLAYLISTS/SAVE_REQUEST':
    case 'PLAYLISTS/DELETE_REQUEST':
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case 'PLAYLISTS/FETCH_ALL_FAILURE':
    case 'PLAYLISTS/FETCH_FAILURE':
    case 'PLAYLISTS/SAVE_FAILURE':
    case 'PLAYLISTS/DELETE_FAILURE':
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case 'PLAYLISTS/FETCH_ALL_SUCCESS':
      return {
        ...state,
        all: action.data,
        isFetching: false,
      };
    case 'PLAYLISTS/FETCH_SUCCESS':
      return {
        ...state,
        all: upsertPlaylist(state.all, action.data),
        isFetching: false,
      };
    case 'PLAYLISTS/SAVE_SUCCESS':
      return {
        ...state,
        all: replacePlaylist(state.all, action.draftId, action.data),
        isFetching: false,
      };
    case 'PLAYLISTS/DELETE_SUCCESS':
      return {
        ...state,
        all: state.all.filter(playlist => playlist._id !== action.id),
        isFetching: false,
      };
    case 'PLAYLISTS/ADD_DRAFT':
      return {
        ...state,
        all: upsertPlaylist(state.all, action.data),
      };
    case 'PLAYLISTS/UPDATE_DRAFT':
      return {
        ...state,
        all: patchPlaylist(state.all, action.id, action.update),
      };
    default:
      return state;
  }
};
